import { render, staticRenderFns } from "./create-dialog.vue?vue&type=template&id=4c45647c&"
import script from "./create-dialog.vue?vue&type=script&lang=ts&"
export * from "./create-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports